import { Injectable } from '@angular/core';
import { FiltersApiService } from '@apps/prtg/api';

import { Observable } from 'rxjs';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';

@Injectable({
    providedIn: 'root'
})
export class FiltersDomainService extends BaseMiscDomainService
{
    constructor (
        private filtersApiService: FiltersApiService
    )
    {
        super();
    }

    getFilters (): Observable<string[]>
    {
        return this.filtersApiService.getFilters();
    }
}
